export const locales = ["fr", "en", "es"] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "fr";

export const localeNames: Record<Locale, string> = {
  fr: "Fran\u00e7ais",
  en: "English",
  es: "Espa\u00f1ol",
};

/** Code BCP-47 pour Intl.DateTimeFormat / NumberFormat. */
export const intlLocales: Record<Locale, string> = {
  fr: "fr-FR",
  en: "en-US",
  es: "es-ES",
};
export function intlLocale(locale: string): string {
  return intlLocales[locale as Locale] ?? intlLocales.en;
}

/* \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
   Logo par langue

   Le logo RLCore porte sa baseline DANS l'image : \u00ab AGENCE WEB \u00bb,
   \u00ab WEB AGENCY \u00bb, \u00ab AGENCIA WEB \u00bb. Un visiteur anglophone qui voit
   \u00ab AGENCE WEB \u00bb lit une incoh\u00e9rence \u2014 l'image suit donc la langue
   de la page, au m\u00eame titre que les textes.

   Sources : Assets/marque/2026-08_multilingue/ (originaux \u00e0 fond plein)
   \u2192 d\u00e9tour\u00e9s vers public/logo/.
   \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */

/** Langue \u2192 logo d\u00e9tour\u00e9 (encre blanche, pour les fonds sombres). */
const brandLogos: Partial<Record<Locale, string>> = {
  fr: "/logo/logo-fr.png",
  en: "/logo/logo-en.png",
  es: "/logo/logo-es.png",
};

/** Variante encre noire, pour les fonds clairs (e-mails, PDF, impression). */
const brandLogosInk: Partial<Record<Locale, string>> = {
  fr: "/logo/logo-fr-encre.png",
  en: "/logo/logo-en-encre.png",
  es: "/logo/logo-es-encre.png",
};

/**
 * Logo de la marque pour la langue donn\u00e9e.
 * Repli sur le fran\u00e7ais si la langue n'a pas (encore) son fichier.
 */
export function brandLogo(locale: string, ink = false): string {
  const table = ink ? brandLogosInk : brandLogos;
  return (
    table[locale as Locale] ??
    table[defaultLocale] ??
    brandLogos[defaultLocale] ??
    "/logo.png"
  );
}

/** Code OpenGraph (underscore) pour les m\u00e9tadonn\u00e9es. */
export const ogLocales: Record<Locale, string> = {
  fr: "fr_FR",
  en: "en_US",
  es: "es_ES",
};
export function ogLocale(locale: string): string {
  return ogLocales[locale as Locale] ?? ogLocales.en;
}
